module.exports = __webpack_public_path__ + "media/assets/images/category_image_placeholder-beea7efa264ea9abbd9d60619d3cd018.svg";